var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.94043,
    y: 0.838226,
    width: 21.6868,
    height: 21.6868,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10027 8.47587C7.90681 8.47587 8.56065 7.82204 8.56065 7.01549C8.56065 6.20895 7.90681 5.55511 7.10027 5.55511C6.29373 5.55511 5.63989 6.20895 5.63989 7.01549C5.63989 7.82204 6.29373 8.47587 7.10027 8.47587Z",
    fill: "#2962FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93956 9.5825V17.6847H12.4552V13.678C12.4552 12.6207 12.6541 11.5969 13.9649 11.5969C15.2578 11.5969 15.2738 12.8056 15.2738 13.7447V17.6853H17.7908V13.2421C17.7908 11.0596 17.3209 9.38226 14.7699 9.38226C13.5451 9.38226 12.7242 10.0544 12.3884 10.6905H12.3544V9.5825H9.93956ZM5.84009 9.5825H8.35971V17.6847H5.84009V9.5825Z",
    fill: "#2962FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.03127554cc1d91da7c7e5fbd3d05c8fc.svg";
export { ForwardRef as ReactComponent };